export const PROTOCOL_VERSION = 1;

export function createDiagnosticSummary(errorCode: string, appVersion: string): string {
  const safeCode = /^[A-Z][A-Z0-9_]*$/u.test(errorCode) ? errorCode : 'PROTOCOL_INVALID';
  const safeVersion = /^[A-Za-z0-9._-]+$/u.test(appVersion) ? appVersion : 'unknown';
  return `protocolVersion=${PROTOCOL_VERSION}\nerrorCode=${safeCode}\nappVersion=${safeVersion}`;
}
